import { getDistanceBetweenUserAndSpot } from './getDistanceBetweenUserAndSpot'
import constants from '@/helpers/constants'
import PhoneFormatter from '@/filters/PhoneFormatter'

export const createMapInfoModal = (spot, mailName, ourMailName, translations, productInfo, isAdmin) => {
  let button = `<button class="map-info-modal__btn">${translations('choose')}</button>`
  let distanceToSpot = ''
  let servicesListForShops = ''
  let spotSchedule = ''
  let serviceName = ''
  let serviceSchedule = ''
  let infoModalTitle = isAdmin ? translations('warehouse_title') : ''

  if (spot.isAvailable && spot.isAvailable === '0') {
    button = `<p class="map-info-modal__sorry">${translations('warehouse_not_available')}</p>`
  } else if (spot.isSuccessful || spot.cartStatus === constants.CART_STATUSES.NOT_AVAILABLE) {
    button = ''
  } else if (!constants.IS_CHECKOUT()) {
    if (!spot.googleLink && !spot.latitude) {
      button = ''
    } else {
      const url = spot.googleLink || `//maps.google.com?saddr=Current+Location&daddr=${spot.latitude},${spot.longitude}`

      button = `
      <a href="${url}" target="_blank" rel="noreferrer" class="map-info-modal__btn">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.7622 7.43399L8.56218 0.234C8.25018 -0.0779999 7.74216 -0.0779999 7.43418 0.234L0.234183 7.43399C-0.0778168 7.74599 -0.0778168 8.25401 0.234183 8.56601L7.43418 15.762V15.766C7.74618 16.078 8.25419 16.078 8.56619 15.766L15.7662 8.56601C16.0781 8.24999 16.0781 7.74599 15.7622 7.43399ZM9.59815 9.99798V7.99799H6.39816V10.398H4.79815V7.19801C4.79815 6.75401 5.15414 6.39802 5.59814 6.39802H9.59815V4.398L12.3982 7.19801L9.59815 9.99798Z" fill="#F8F8F8"/>
        </svg>
        ${translations('site.shops.bulid.route')}
      </a>`
    }
  }

  if (getDistanceBetweenUserAndSpot(spot) && ((constants.IS_CHECKOUT() && !constants.IS_CHECKOUT_SUCCESS()) || constants.IS_PRODUCT)) {
    distanceToSpot = `<p class="map-info-modal__distance reserve-info__distance">~${getDistanceBetweenUserAndSpot(spot)} ${translations('from_location')}</p>`
  }
  if (spot.placement === constants.MAP_PLACEMENTS.SHOPS || spot.placement === constants.MAP_PLACEMENTS.SERVICES) {
    if (spot.scheduleObj.schedule) {
      spotSchedule = spot.scheduleObj.schedule
    }

    if (spot.storesServices[0]) {
      serviceName = spot.storesServices[0].name
      serviceSchedule = spot.storesServices[0].scheduleObj.schedule
    }

    servicesListForShops += '<ul class="shop-services">'
    spot.services.forEach(el => {
      servicesListForShops += `
        <li class="shop-services__item">
          <img src="${el.icon}" alt="${el.label}" class="shop-services__item-icon">
          <span class="shop-services__item-label">${el.label}</span>
        </li>`
    })
    servicesListForShops += '</ul>'

    if (isAdmin) {
      if (spot.type === `brand_store`) {
        infoModalTitle = translations('brandStoreName')
        servicesListForShops += `
          <br>
          <ul class="shop-services">
            <li class="shop-services__item shop-services__item--si">${translations('productsAvailableErp')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('priceLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('saleLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('bonusesProgramOur')}</li>
          </ul>`
      } else if (spot.type === `partner_store`) {
        infoModalTitle = translations('partnerStoreName')
        servicesListForShops += `
          <br>
          <ul class="shop-services">
            <li class="shop-services__item shop-services__item--si">${translations('productsAvailablePhone')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('priceLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('saleLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('bonusesProgramPartner')}</li>
          </ul>`
      } else if (spot.type === `franchisees_store`) {
        infoModalTitle = translations('franchiseesStoreName')
        servicesListForShops += `
          <br>
          <ul class="shop-services">
            <li class="shop-services__item shop-services__item--si">${translations('productsAvailable')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('priceLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('saleLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('bonusesProgramOur')}</li>
          </ul>`
      } else if (spot.type === `ofp_store`) {
        infoModalTitle = translations('ofpStoreName')
        servicesListForShops += `
          <br>
          <ul class="shop-services">
            <li class="shop-services__item shop-services__item--si">${translations('productsAvailablePhone')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('priceLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('saleNotLikeSite')}</li>
            <li class="shop-services__item shop-services__item--si">${translations('bonusesProgramPartner')}</li>
          </ul>`
      }
    }
  }

  if (constants.IS_PRODUCT) {
    // const preOrderBtn = `<button data-link="${spot.googleLink || `//maps.google.com?saddr=Current+Location&daddr=${spot.latitude},${spot.longitude}`}" data-title="${spot.description_ru}" data-map="${spot.staticMapLink}" data-id="${spot.storeId}" data-quantity="${spot.quantity}"  data-status="${spot.status}" id="pre-order-btn" class="reserve-info__btn reserve-info__btn--inverse">${translations('pre_order')}</button>`
    const reserveBtn = `<button data-link="${spot.googleLink || `//maps.google.com?saddr=Current+Location&daddr=${spot.latitude},${spot.longitude}`}" data-title="${spot.description_ru}" data-map="${spot.staticMapLink}" data-id="${spot.storeId}" data-quantity="${spot.quantity}"  data-status="${spot.status}" id="reserve-btn" class="reserve-info__btn">${translations('reserve_to_reserve')}</button>`
    const buyBtn = `<button data-id="${spot.storeId}" id="reserve-buy-btn" class="reserve-info__btn reserve-info__btn--inverse">${translations('reserve_to_cart')}</button>`
    const waitListBtn = `<button data-id="${spot.storeId}" data-wait-list-status="${spot.isInWaitList}" id="wait-list-btn-${spot.storeId}" class="reserve-info__btn reserve-info__btn--wait-list">${spot.isInWaitList ? translations('already_in_wait_list') : translations('add_to_wait_list')}</button>`
    let productQuantity
    let spotStatus

    let buttonsWrap = '' +
      `<div class="reserve-info__btns-wrap">` +
      reserveBtn +
      buyBtn +
      `</div>`

    if (spot.quantity || spot.quantity === 0) {
      if (spot.quantity > 3) {
        productQuantity = translations('reserve_more_then')
      } else if (spot.quantity > 0 && spot.quantity <= 3) {
        productQuantity = translations('reserve_in_stock') + ' ' + spot.quantity + ' шт'
      // } else if (spot.status === 4) {
      //   productQuantity = translations('reserve_pre_order')
      } else {
        productQuantity = translations('reserve_not_in_stock')
      }
    }

    if (spot.status || spot.status === 0) {
      if (spot.status === 0 || (spot.status === 4 && spot.quantity < 1)) {
        spotStatus = translations('reserve_order_not_available')
        buttonsWrap = `<div class="reserve-info__btns-wrap">` + waitListBtn + `</div>`
      } else if (spot.status === 1) {
        spotStatus = translations('reserve_now_in_stock')
      } else if (spot.status === 2) {
        spotStatus = translations('reserve_will_be_in_stock')
      } else if (spot.status === 4 && spot.quantity > 0) {
        spotStatus = translations('reserve_now_in_stock')
      } else {
        spotStatus = ''
      // } else if (spot.status === 4) {
      //   spotStatus = ''
      //   buttonsWrap = `<div class="reserve-info__btns-wrap">` + preOrderBtn + `</div>`
      }
    }

    return '' +
      `<div class="reserve-info reserve-info--modal">` +
      `<h2 class="reserve-info__title">${spot.title || spot.description_ru}</h2>` +
      distanceToSpot +
      `<div class="reserve-info__shedule-wrap">` +
      `<span class="reserve-info__shedule">${spot.schedule}</span>` +
      `<span class="reserve-info__phone">${PhoneFormatter(spot.phone)}</span>` +
      `</div>` +
      `<span class="reserve-info__quantity ${spot.quantity > 0 ? 'reserve-info__quantity--in-stock' : ''}">${productQuantity}</span>` +
      `<span class="reserve-info__delivery-text">${spotStatus}</span>` +
      buttonsWrap +
      `</div>`
  }

  if (mailName === 'novaPoshtaWarehouse' || mailName === 'novaPoshtaParcel') {
    const parsedSchedule = constants.IS_CHECKOUT_SUCCESS() ? spot.schedule : JSON.parse(spot.schedule)
    const officeNumber = constants.IS_CHECKOUT_SUCCESS() ? '' : `<h2 class="map-info-modal__title">№${spot.officeNumber}</h2>`
    let schedule = ''
    if (spot.isActive) {
      Object.keys(parsedSchedule).forEach((item) => {
        schedule = schedule + `<p class="map-info-modal__schedule">${translations(item + '_short').toUpperCase()} ${parsedSchedule[item]}</p>`
      })
    }
    return '' +
      '<div class="map-info-modal">' +
      officeNumber +
      distanceToSpot +
      `<p class="map-info-modal__address">${spot.description_ru || spot.title}</p>` +
      schedule +
      button +
      '</div>'
  } else if (mailName === 'pickup' || ourMailName === 'pickup') {
    let cartStatus
    let modificator
    let cartStatusHtml = ''
    if (spot.cartStatus || spot.cartStatus === constants.CART_STATUSES.NOT_AVAILABLE) {
      if (spot.cartStatus === constants.CART_STATUSES.NOT_AVAILABLE) {
        cartStatus = translations('reserve_order_not_available')
        modificator = 'map-info-modal__status--not-in-stock'
      } else if (spot.cartStatus === constants.CART_STATUSES.TODAY) {
        cartStatus = translations('reserve_now_in_stock')
        modificator = 'map-info-modal__status--in-stock'
      } else if (spot.cartStatus === constants.CART_STATUSES.NEXT_DAYS) {
        cartStatus = translations('reserve_will_be_in_stock')
        modificator = 'map-info-modal__status--will-be-in-stock'
      }
    }

    if (cartStatus) {
      cartStatusHtml = `<p class="map-info-modal__status ${modificator}">${cartStatus}</p>`
    }

    if (spot.placement === constants.MAP_PLACEMENTS.SHOPS) {
      return '<div class="map-info-modal map-info-modal--shops">' +
        `<div class="map-info-modal__left-wrap">` +
        `<div class="map-info-modal__img-wrapper">` +
        `<img class="map-info-modal__img" src="${'/img/shops/' + spot.image}" alt="${spot.title || spot.description_ru}">` +
        `</div>` +
        `<div class="map-info-modal__info-wrap">` +
        (isAdmin ? `<h2 class="map-info-modal__title">${infoModalTitle}</h2>` : '') +
        `<p class="map-info-modal__address">${spot.title || spot.description_ru}</p>` +
        `<p class="map-info-modal__status" style="background-color: ${spot.scheduleObj.label.color}">${translations(`${spot.scheduleObj.label.translationKey}`)}</p>` +
        `<div class="map-info-modal__schedule-wrap">` +
        `<div class="map-info-modal__schedule-item">` +
        `<p class="map-info-modal__schedule-title">${translations('shops_shop_schedule_label')}</p>` +
        `<p class="map-info-modal__schedule">${spotSchedule}</p>` +
        `</div>` +
        `<div class="map-info-modal__schedule-item">` +
        `<p class="map-info-modal__schedule-title">${serviceName}</p>` +
        `<p class="map-info-modal__schedule">${serviceSchedule}</p>` +
        `</div>` +
        `</div>` +
        `<a href="tel:${spot.phone}" class="map-info-modal__phone">${spot.phone}</a>` +
        `</div>` +
        `</div>` +
        `<div class="map-info-modal__right-wrap">` +
        servicesListForShops +
        button +
        `</div>` +
        '</div>'
    }

    if (spot.placement === constants.MAP_PLACEMENTS.SERVICES) {
      return '<div class="map-info-modal map-info-modal--services">' +
        `<div class="map-info-modal__info-wrap">` +
        `<p class="map-info-modal__address">${spot.city}, ${spot.title || spot.description_ru}</p>` +
        `<p class="map-info-modal__status" style="color: ${spot.scheduleObj.label.color}">${translations(`${spot.scheduleObj.label.translationKey}`)}</p>` +
        `<div class="map-info-modal__schedule-item">` +
        `<p class="map-info-modal__schedule">${spotSchedule}</p>` +
        `</div>` +
        `<span class="map-info-modal__phone">${spot.phone}</span>` +
        `</div>` +
        button +
        '</div>'
    }

    return '' +
      '<div class="map-info-modal">' +
      `<h2 class="map-info-modal__title">${infoModalTitle}</h2>` +
      distanceToSpot +
      `<p class="map-info-modal__address">${spot.title || spot.description_ru}</p>` +
      `<p class="map-info-modal__schedule">${spot.schedule}</p>` +
      `<p class="map-info-modal__phone">${spot.phone}</p>` +
      cartStatusHtml +
      servicesListForShops +
      button +
      '</div>'
  } else {
    const phone = spot.phone ? spot.phone : ''

    return '' +
      '<div class="map-info-modal">' +
      `<h2 class="map-info-modal__title">${translations('ukrposhta_title')}</h2>` +
      distanceToSpot +
      `<p class="map-info-modal__address">${spot.description_ru}</p>` +
      `<p class="map-info-modal__schedule">${phone}</p>` +
      button +
      '</div>'
  }
}
